import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import invariant from '../utils/invariant';
import getScreenForRouteName from './getScreenForRouteName';
import validateScreenOptions from './validateScreenOptions';
function applyConfig(configurer, navigationOptions, configProps) {
  if (typeof configurer === 'function') {
    return _objectSpread(_objectSpread({}, navigationOptions), configurer(_objectSpread(_objectSpread({}, configProps), {}, {
      navigationOptions: navigationOptions
    })));
  }
  if (typeof configurer === 'object') {
    return _objectSpread(_objectSpread({}, navigationOptions), configurer);
  }
  return navigationOptions;
}
export default (function (routeConfigs, navigatorScreenConfig) {
  return function (navigation, screenProps, theme) {
    var state = navigation.state;
    var route = state;
    invariant(route.routeName && typeof route.routeName === 'string', 'Cannot get config because the route does not have a routeName.');
    var Component = getScreenForRouteName(routeConfigs, route.routeName);
    var routeConfig = routeConfigs[route.routeName];
    var routeScreenConfig = routeConfig === Component ? null : routeConfig.navigationOptions;
    var componentScreenConfig = Component.navigationOptions;
    var configOptions = {
      navigation: navigation,
      screenProps: screenProps || {},
      theme: theme
    };
    var outputConfig = applyConfig(navigatorScreenConfig, {}, configOptions);
    outputConfig = applyConfig(componentScreenConfig, outputConfig, configOptions);
    outputConfig = applyConfig(routeScreenConfig, outputConfig, configOptions);
    validateScreenOptions(outputConfig, route);
    return outputConfig;
  };
});